import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
function UxDesign() {
    return (
        <div>
            <Header/>
        <DetailService
            titre="UX/UI Design"
            categorie="Cognitique"
            image="/images/cognitique2.avif"
            description="L'UX/UI Design est l'une de nos spécialités. L'UX (expérience utilisateur) englobe l’ensemble des interactions qu’un utilisateur a avec un produit ou un service. L’UI (interface utilisateur), quant à elle, concerne la partie visuelle et interactive, incluant la disposition des éléments, les couleurs, les polices et les boutons. Le maquettage, réalisé par nos intervenants, est essentiel pour garantir le succès d’un produit, qu’il s’agisse d’un site web ou d’une application mobile, en assurant une expérience utilisateur fluide et optimale."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage du besoin client',
                    texte: 'Identification des objectifs, des cibles utilisateurs et des contraintes du projet. Nous définissons ensemble le périmètre de la mission et les critères de succès.',
                },
                {
                    numero: 2,
                    titre: 'Recherche utilisateur',
                    texte: 'Entretiens, questionnaires et observations pour comprendre les besoins, usages et frustrations des utilisateurs actuels ou cibles. Ces données orientent toutes les décisions de conception.',
                },
                {
                    numero: 3,
                    titre: 'Maquettage des pages',
                    texte: 'Conception de wireframes puis de maquettes graphiques interactives, soumises à validation par le client. Plusieurs itérations permettent d\'affiner les choix UX et UI avant développement.',
                },
                {
                    numero: 4,
                    titre: 'Tests utilisateurs',
                    texte: 'Sessions de tests avec de vrais utilisateurs pour identifier les problèmes d\'ergonomie et de compréhension. Les résultats alimentent les ajustements finaux de la maquette.',
                },
                {
                    numero: 5,
                    titre: 'Livraison et restitution',
                    texte: 'Remise des livrables (maquettes, design system, rapport de recommandations) et présentation finale au client avec un plan d\'action priorisé.',
                },
            ]}
            realisations={[
                
            ]}
        />
         <Footer/>
        </div>
    );
}

export default UxDesign;
